<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <CustomBreadcrumb :items="items_bread_crumb"  />
      <div class="card card-w-title">
        <div class="row manager-title-row">
          <div class="p-col-4 manager-title-custom">{{ title }}</div>
        </div>
        <!-- <div class="note">(*) Nội dung không được bỏ trống</div> -->
        <formEdit
          :key="componentKey"
          :mode="mode"
          @back="backToList"
          @save="saveData"
          :triggerSave.sync="triggerSave"
          :model="models"/>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import formEdit from "./add"; // file form bạn vừa sửa
import ApiRepository from "@/core/ApiRepository";

export default {
  components: { formEdit },
  data() {
    return {
      items_bread_crumb: [
        { label: "Fixing Car", to: "/admin/list-car_accident" },
        { label: "" },
      ],
      title: "Create",
      mode: "add",
      models: {},
      componentKey: 0,
      page_transaction: null,
      time_zone_local: moment.tz.guess(true),
      triggerSave: false,
    };
  },

  async mounted() {
    this.mode = this.$route.name === "edit" ? "edit" : this.mode;
    this.title = this.mode === "edit" ? "Edit Fixing Car" : "Create Fixing Car";
    this.items_bread_crumb[1].label = this.title;

    if (this.$route.params.id !== undefined) await this.getData(this.$route.params.id);

    if (!this.$commonFuction.isEmpty(this.$route.query?.page_transaction)) {
      this.page_transaction = this.$route.query.page_transaction;
    }

    // check quyền (đổi KEY_MENU theo menu Fixing Car của bạn)
    const arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_CAR_ACCIDENT);
    if (this.mode === "edit") {
      if (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0) {
        this.$router.push({ path: this.$constants.URL_ERR.FOBIDDEN });
      }
    } else {
      if (arr_role.indexOf(this.$constants.ROLE.ADD) < 0) {
        this.$router.push({ path: this.$constants.URL_ERR.FOBIDDEN });
      }
    }
  },

  methods: {
    backToList() {
      const router_back = { path: "/admin/list-car_accident" };
      if (!this.$commonFuction.isEmpty(this.page_transaction)) {
        router_back.query = { page_transaction: this.page_transaction.toString() };
      }
      this.$router.push(router_back);
    },

    async getData(id) {
      try {
        this.$commonFuction.is_loading(true);

        const currentTimezone = moment.tz.guess();
        const headers = {
          Authorization: "Bearer " + (await this.$AuthenticationApp.getToken()),
          Timezone: currentTimezone,
        };

        const res = await ApiRepository.post(
          "/api_admin/order/accident_admin_detail",
          { id },
          { headers }
        );

        const detail = res?.data?.data || null;
        if (!detail) {
          this.$toast.add({
            severity: "error",
            summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: "Not found",
            life: 3000,
          });
          return;
        }

        this.models = detail;
        this.componentKey++;
      } catch (e) {
        console.log("getData accident detail error:", e);
        this.$toast.add({
          severity: "error",
          summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
          detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
          life: 3000,
        });
      } finally {
        this.$commonFuction.is_loading(false);
      }
    },

    async saveData(params) {
      try {
        this.$commonFuction.is_loading(true);

        const currentTimezone = moment.tz.guess();
        const headers = {
          Authorization: "Bearer " + (await this.$AuthenticationApp.getToken()),
          Timezone: currentTimezone,
        };

        // ✅ EDIT: chỉ update note
        if (this.mode === "edit") {
          const payload = {
            id: this.models?.id || params?.id || this.$route.params.id,
            note: params?.note ?? "", // nếu DB là notes => đổi thành notes
            fee:params?.fee ?? 0, 
           // accident_date_at:params?.accident_date_at ?? null,
           // fixing_date_at:params?.fixing_date_at ?? null,
          };
          if(params.accident_date_at){
            if (params.accident_date_at instanceof Date) {
            // Nếu valid_until là đối tượng Date, định dạng lại
              payload.accident_date_at = moment(params.accident_date_at).format('YYYY-MM-DD');
            } else if (typeof params.accident_date_at === 'string') {
              // Nếu valid_until là chuỗi "dd/MM/yyyy", chuyển thành định dạng YYYY-MM-DD
              const regoDate = moment(params.accident_date_at, 'DD/MM/YYYY');
              payload.accident_date_at = regoDate.isValid() ? regoDate.format('YYYY-MM-DD') : null;
            }
          }
          if(params.fixing_date_at){
            if (params.fixing_date_at instanceof Date) {
              payload.fixing_date_at = moment(params.fixing_date_at).format('YYYY-MM-DD');
            } else if (typeof params.fixing_date_at === 'string') {
              const regoDate = moment(params.fixing_date_at, 'DD/MM/YYYY');
              payload.fixing_date_at = regoDate.isValid() ? regoDate.format('YYYY-MM-DD') : null;
            }
          }


          const res = await ApiRepository.post(
            "/api_admin/order/save_accident",
            payload,
            { headers }
          );

          if (res?.data?.is_success === false) {
            throw new Error(res?.data?.message_text || "Update failed");
          }

          this.$toast.add({ severity: "success", summary: "Success", detail: "Save data successfully", life: 3000 });
          this.backToList();
          return;
        }

        // ✅ ADD: tạo mới accident
        const objects = {
          car_for_rent_id: params?.car_for_rent_id ?? null,
          vehicle_category_id: params?.vehicle_category_id ?? null,
          renter_id: params?.renter_id ?? null,
          contact_name: params?.contact_name ?? null,
          contact_phone: params?.contact_phone ?? null,

          accident_date_at: params?.accident_date_at
            ? moment(params.accident_date_at).format("YYYY-MM-DD")
            : null,
          fixing_date_at: params?.fixing_date_at
            ? moment(params.fixing_date_at).format("YYYY-MM-DD")
            : null,

          fee: params?.fee ?? 0,
          note: params?.note ?? null, // nếu DB là notes => đổi thành notes
          created_at: moment.tz(new Date(), this.time_zone_local),
          created_by: this.$store.getters.user,
        };

        const resAdd = await ApiRepository.post(
          "/api_admin/order/accident_admin_create",
          objects,
          { headers }
        );

        if (resAdd?.data?.is_success === false) {
          throw new Error(resAdd?.data?.message_text || "Create failed");
        }

        this.$toast.add({ severity: "success", summary: "Success", detail: "Save data successfully", life: 3000 });
        this.backToList();
      } catch (e) {
        console.log("saveData error:", e);
        this.$toast.add({
          severity: "error",
          summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
          detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
          life: 3000,
        });
      } finally {
        this.$commonFuction.is_loading(false);
      }
    },
  },
};
</script>

<style lang="scss">
.manager-title-custom {
  color: #1D3118;
  font-size: 24px;
  /* margin-bottom: 16px; */
  padding-bottom: 10px;
  /* border-bottom: 1px solid #EEEEEE; */
  font-weight: 700;
  margin-left: 20px;
}
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.note{ letter-spacing: 0px; color: #707070; margin-bottom: 24px; padding-top: 10px;}
.p-formgrid { margin: 0;
  .p-panel-header {color: #000000; font-size: 18px; font-weight: bold; background: #EEEEEE;}
  .p-card-field{ padding: 24px;
    .p-field{
      .p-col-fixed { width: 300px; display: inline-block !important; margin: 0;}
      .p-col-width{width:500px !important; border-radius: 5px;
        &.disabled{background: #EEEEEE; border: 0 none; padding: 8px 10px;}
        .file-select{margin: 0;
          input[type="file"]{display: none;}
          .select-button{display: inline-block; cursor: pointer; background: transparent; border-radius: 5px;  color: #000000; font-size: 13px; padding: 3px 16px;  border: 1px solid #B4B4B4;}
        }
        &.pac-target-input{ height: 80px;  word-break: break-all; overflow-wrap: break-word;  resize: none;}
      }
      .box-images{ margin: 0; margin-top: 10px; position: relative;
        .item-img{width: 150px; height: 150px;  margin-right: 8px; margin-bottom: 8px; display: inline-flex; position: relative;
          img{max-width: 100%; height: auto;margin: 0 auto; object-fit: contain; padding: 5px;}
          .button-clear{border-radius: 10px; width: 24px; height: 24px; background: #F5564E; float: right; cursor: pointer; position: absolute; right: 0px;
            img{vertical-align: top;}
          }
        }
      }
      .p-invalid{display: block;}
    }
  }
  .fixed-bottom-toolbar{background: transparent; border: 0 none; margin-top: 22px; border-top: 1px solid #B4B4B4; padding: 0; padding-top: 30px;
    .p-button{width: auto; margin-right: 8px;
      &:last-child{margin-right: 0;}
    }
  }
}
.manager-title-row{
  border-bottom: 1px solid #EEEEEE;
}
.p-toolbar-group-right {
  flex-basis: 30%;
}
.p-button-warning.p-button {
  margin: 0 10px;
}
</style>